import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Section, SectionContent, SectionItem, SectionTitle } from './atoms';
import { CampaignDetail, VerticalType } from '@/apis/core';
import {
  selectCountries,
  selectVerticalTypes,
} from '@/shared_elements/selectors';

interface BrandDetailsSectionProps {
  campaign: CampaignDetail;
}

export const BrandDetailsSection: FC<BrandDetailsSectionProps> = ({
  campaign,
}) => {
  const verticalTypes = useSelector(selectVerticalTypes);
  const countries = useSelector(selectCountries);
  const verticalTypeMapping = useMemo(
    () =>
      verticalTypes.reduce((accumulator, verticalType) => {
        accumulator[verticalType.id] = verticalType;
        return accumulator;
      }, {} as Record<string, VerticalType>),
    [verticalTypes]
  );
  const { brand } = campaign;

  return (
    <Section>
      <SectionTitle>Brand Details</SectionTitle>
      <SectionContent>
        <SectionItem title="Brand Legal Name">{brand.companyName}</SectionItem>
        <SectionItem title="Brand ID">{brand.uid}</SectionItem>
        <SectionItem title="Country">
          {countries[brand.country] ?? brand.country}
        </SectionItem>
        <SectionItem title="State / Region">{brand.state}</SectionItem>
        <SectionItem title="Company Registration Number">
          {brand.ein}
        </SectionItem>
        <SectionItem title="Company Registration Number / ID Issuing Country">
          {countries[brand.einIssuingCountry] ?? brand.einIssuingCountry}
        </SectionItem>
        <SectionItem title="Stock Symbol">{brand.stockSymbol}</SectionItem>
        <SectionItem title="Stock Exchange">{brand.stockExchange}</SectionItem>
        <SectionItem title="Support Phone Number">{brand.phone}</SectionItem>
        <SectionItem title="Website / Online Presence">
          {brand.website}
        </SectionItem>
        <SectionItem title="Vertical">
          {verticalTypeMapping[brand.vertical ?? '']?.displayName ??
            brand.vertical}
        </SectionItem>
      </SectionContent>
    </Section>
  );
};

export default BrandDetailsSection;
